export default "__VITE_PUBLIC_ASSET__da233964__"